<!-- 动态验证 -->
<template>
  <div>
    <li>
      <a-input
        size="large"
        v-model="formData.text"
        type="text"
        placeholder="请输入手机号码或电子邮箱"
      />
    </li>
    <li>
      <a-input-search
        size="large"
        allowClear
        v-model="formData.code"
        :maxLength="6"
        placeholder="请输入验证码"
        :enter-button="buttonText"
        @search="getCode"
      />
    </li>
  </div>
</template>

<script>
import { validatePhoneNumber, validateEmail } from "@/utils/util";
export default {
  name: "DynamicVerification",
  data() {
    return {
      formData: {
        text: "",
        code: "",
      },
      timer: undefined,
      isGetCode: false,
      count: 60,
      buttonText: "获取验证码",
    };
  },
  methods: {
    // 获取验证码
    async getCode() {
      if (this.isGetCode) {
        this.$message.error("请勿频繁获取");
        return;
      }
      if (this.formData.text == "" || !this.formData.text) {
        this.$message.warning("请输入手机号码或邮箱");
        return;
      }

      if (
        !validatePhoneNumber(this.formData.text) &&
        !validateEmail(this.formData.text)
      ) {
        this.$message.warning("请输入正确的手机号码或邮箱");
        return;
      }
      if (!!this.timer) return;
      this.isGetCode = true;
      const bool = await this.send();

      if (!bool) return;

      this.timer = setInterval(() => {
        if (this.count == 0) {
          clearInterval(this.timer);
          this.timer = undefined;
          this.count = 60;
          this.isGetCode = false;
          this.buttonText = "获取验证码";
          return;
        }
        this.buttonText = `剩余${this.count}秒`;
        this.count--;
      }, 1000);
    },
    async send() {
      const res = await this.$post("/api/BizReceipt/Send", {
        alias: this.$route.query.alias,
        ...this.formData,
        type: 5,
      });
      if (res.code === 200) {
        this.$message.success("发送成功");
        return true;
      } else {
        this.isGetCode = false;
        return false;
      }
    },
    async submit() {
      const { formData } = this;
      if (!formData.text || formData.text === "") {
        this.$message.warning("请输入手机号码或邮箱");
        return;
      }
      if (!formData.code || formData.code === "") {
        this.$message.warning("请输入验证码");
        return;
      }

      this.$emit("submit", this.formData);
      return;
    },
  },
};
</script>
